export default "__VITE_ASSET__4DD_5KXb__"